module.exports = __webpack_public_path__ + "static/media/sp.9f85deeb.svg";